<template>
    <el-input
        v-if="question.isNCBValidatorType"
        v-model="question.data.return_value"
        size="small"
        class="w-75"
        v-mask="'AAAA-######-#'"
    >
        <template slot="suffix">
            <span :class="valid ? 'text-success' : 'text-danger'">
                <i :class="valid ? 'fa fa-check' : 'fa fa-times'"></i>
            </span>
        </template>
    </el-input>
    <el-input
        v-else
        v-model="question.data.return_value"
        size="small"
        :placeholder="question.caption"
        :type="question.isTextArea ? 'textarea' : 'text'"
        :rows="question.isTextArea ? 3 : 1"
        @change="hideKeyboard"
    ></el-input>
</template>

<script>
import { mask } from 'vue-the-mask';
import FormQuestion from '@/data/FormQuestion';

export default {
    props: {
        question: {
            type: FormQuestion,
            required: true,
        },
    },
    directives: { mask },
    data() {
        return {
            ncbValidationMap: {
                A: 10,
                B: 12,
                C: 13,
                D: 14,
                E: 15,
                F: 16,
                G: 17,
                H: 18,
                I: 19,
                J: 20,
                K: 21,
                L: 23,
                M: 24,
                N: 25,
                O: 26,
                P: 27,
                Q: 28,
                R: 29,
                S: 30,
                T: 31,
                U: 32,
                V: 34,
                W: 35,
                X: 36,
                Y: 37,
                Z: 38,
            },
        };
    },
    computed: {
        valid() {
            if (this.question.data.return_value && this.question.data.return_value.length === 13) {
                const firstDigits = this.question.data.return_value.slice(0, 4);
                const middleDigits = this.question.data.return_value.slice(5, 11);
                let middleDigitCounter = 0;
                const lastDigit = this.question.data.return_value.slice(12, 13);
                let calculation = 0;

                for (let i = 0; i < 10; i += 1) {
                    if (i < 4) {
                        calculation += 2 ** i * this.ncbValidationMap[firstDigits[i]];
                    } else {
                        calculation += 2 ** i * middleDigits[middleDigitCounter];
                        middleDigitCounter += 1;
                    }
                }

                return calculation - Math.floor(calculation / 11) * 11 === +lastDigit;
            }

            return false;
        },
    },
    methods: {
        hideKeyboard() {
            document.activeElement.blur();
        },
    },
};
</script>
